export default {
    usExchangeList : ['NASDAQ', 'NYSE', 'NYSE ARCA', 'CBOE BZX', 'NYSE AMERICAN'],
    ////--------------------------------------------Live configuration-------------------------------------------///
    USER_API:process.env.VUE_APP_USER_API || "https://webapi.protrader.com.au/",
    CHARTING_API: process.env.VUE_APP_CORE || "https://core.protrader.com.au/api/v1",

    ////-------------live stripe price ids-------------
    // Monthly_priceId:process.env.VUE_APP_MONTHLY_PRICE ||"price_1OCCGXG6YGnUUug3EU4QcoxV",
    // Yearly_priceId: process.env.VUE_APP_YEARLY_PRICE || "price_1OCCGXG6YGnUUug3lbzjuNIh",
    // US_priceId: ['price_1OA2tZG6YGnUUug30heVHxjK', 'price_1KddgsG6YGnUUug3coVLxMbq', 'price_1RCHfcG6YGnUUug3ws4zFdSW', 'price_1REVCLG6YGnUUug31lRWODsg', 'price_1REVCeG6YGnUUug3YWcYpehu', 'price_1REVCLG6YGnUUug31lRWODsg'],
    
    //old price ids
    // Monthly_priceId:"price_1OCCGXG6YGnUUug3EU4QcoxV",
    // Yearly_priceId:"price_1OCCGXG6YGnUUug3lbzjuNIh",
    // Monthly_noASX_priceId:"price_1T6W7PG6YGnUUug3UKUF8GXv",
    // Yearly_noASX_priceId:"price_1SGuVDG6YGnUUug323YUZEwC",
    // Monthly_AUD_priceId:"price_1Mseh1G6YGnUUug3NP0HczcX",
    // Yearly_AUD_priceId:"price_1RU41vG6YGnUUug3zuMzSuMn",
    // Monthly_noASX_AUD_priceId:"price_1SzqmtG6YGnUUug31SXSMM7l",
    // Yearly_noASX_AUD_priceId:"price_1SzqmPG6YGnUUug3zZLTA3wf",
    

    //new price ids
    Monthly_priceId:"price_1T7CxkG6YGnUUug3qH26ZvOJ",
    Yearly_priceId:"price_1T7D0zG6YGnUUug3FCUKMuDs",
    Monthly_noASX_priceId:"price_1T7CpPG6YGnUUug3MUAoSkug",
    Yearly_noASX_priceId:"price_1T7CtGG6YGnUUug33GCLnPNY",
    Monthly_AUD_priceId:"price_1T7CyxG6YGnUUug3u11L74B1",
    Yearly_AUD_priceId:"price_1T7D3OG6YGnUUug3Z4CWOYIZ",
    Monthly_noASX_AUD_priceId:"price_1T7Cv4G6YGnUUug3m6gPpmar",
    Yearly_noASX_AUD_priceId:"price_1T7CwYG6YGnUUug3Swki8ADg",
    Monthly_ForumOnly_priceId:"price_1TP0hpG6YGnUUug3u8q4jxyS",
    Monthly_ForumOnly_AUD_priceId:"price_1TP0gJG6YGnUUug38H2tymKh",
    US_priceId:['price_1T7CwYG6YGnUUug3Swki8ADg', 'price_1T7CtGG6YGnUUug33GCLnPNY', 'price_1T7Cv4G6YGnUUug3m6gPpmar', 'price_1T7CpPG6YGnUUug3MUAoSkug', 'price_1SGuUhG6YGnUUug3I1yoQpzQ', 'price_1T6W7PG6YGnUUug3UKUF8GXv', 'price_1SGuVDG6YGnUUug323YUZEwC', 'price_1SzqmtG6YGnUUug31SXSMM7l', 'price_1SzqmPG6YGnUUug3zZLTA3wf'],
    STRIPE_PUBLISHABLE_KEY: process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY || "pk_live_kWDPZURuMcVTpmo2dc6NBLAD",
    



    // ////--------------------------------------------Developer configuration-------------------------------------------///
    // USER_API:process.env.VUE_APP_USER_API || "http://localhost:9090",
    // CHARTING_API: process.env.VUE_APP_CORE || "http://localhost:5000/api/v1",




    // ////-------------test stripe price ids-------------
    // US_priceId: ['price_1SY4b0G6YGnUUug3Rj6GOU8H', 'price_1SY4btG6YGnUUug3oi2g9MYb','price_1ShT2ZG6YGnUUug3YTQZfBYd', 'price_1ShT3sG6YGnUUug3KKyGgE6n'],
    // STRIPE_PUBLISHABLE_KEY: process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY || "pk_test_2i4kRdzD0J2DuVlOb4sAXhsu",

    // Monthly_priceId:"price_1REVCeG6YGnUUug3YWcYpehu",
    // Yearly_priceId:"price_1REVCLG6YGnUUug31lRWODsg",
    // Monthly_noASX_priceId:"price_1SY4b0G6YGnUUug3Rj6GOU8H",
    // Yearly_noASX_priceId:"price_1SY4btG6YGnUUug3oi2g9MYb",
    // Monthly_AUD_priceId:"price_1OKEcwG6YGnUUug3mkoZ0McK",
    // Yearly_AUD_priceId:"price_1OKEgkG6YGnUUug3fZfAGEdD",
    // Monthly_noASX_AUD_priceId:"price_1ShT2ZG6YGnUUug3YTQZfBYd",
    // Yearly_noASX_AUD_priceId:"price_1ShT3sG6YGnUUug3KKyGgE6n",
    // Monthly_ForumOnly_priceId:"price_1TPd3WG6YGnUUug3ygkiSidm",
    // Monthly_ForumOnly_AUD_priceId:"price_1TPd4VG6YGnUUug3gygum7el",

    

    FRIDAY_BROADCAST_LINK:"https://tradingroom.protraderscans.com/t/friday-broadcasts-frank-watkins",
    TRANING_ROOM_LINK:"https://tradingroom.protraderscans.com",
    INTERVAL_POPUP_TIME: 15*60*1000,
    SUB_EXP_POPUP_TIME: 0.05*60*1000,
    TRIAL_DAYS: 14,
    SUB_EXP_NOTIFICATION_DAYS: 3,
    SUPPORT_EMAIL:'support(at)protrader.com.au',
    LINK_PASSCODE:"PT-382796",
    IFRAME_URL:"https://apps.abacus.ai/chatllm/?appId=42fe7b7be&hideTopBar=2",
    GA4_MEASUREMENT_ID: process.env.VUE_APP_GA4_MEASUREMENT_ID || "G-SX662K6VHS",
    GA4_DEBUG_MODE: false, // Enables real-time streaming to GA4 DebugView
    CLARITY_PROJECT_ID: process.env.VUE_APP_CLARITY_PROJECT_ID || "yi1e4dseze",
    // CLARITY_DEBUG_MODE: process.env.NODE_ENV !== 'production',
    CLARITY_DEBUG_MODE: false,
}

